//store/modules/auth.js
/* eslint-disable */
import axios from 'axios';
const state = {
  user: null
};
const getters = {
  isAuthenticated: state => !!state.user,    
  StateUser: state => state.user,
};
const actions = {
  async Register({dispatch}, form) {
    try {
      const res = await axios.post('auth/signup', form, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if(res) {
        await dispatch('LogIn', form)
      }
    }
    catch(err) {
      console.log(err)
    }
  },

  async LogIn({commit}, User) {
    const response = await axios.post('auth/login', User)
    await commit('setUser', response.data)
  },

  async LogOut({commit}){
    let user = null
    await axios.get('user/logout');
    commit('logout', user)
  },

  async SetUser({commit}, data) {
    console.log(data)
    await commit('setUser', data)
  },
  

};
const mutations = {
  setUser(state, user){
      state.user = user
  },

  logout(state){
      state.user = null
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
